import { LoadingSpinnerContainer } from 'component/progress/loading-spinner';
import { useFocusEffect, useRouter } from 'expo-router';
import { useFirstConversationKey } from 'structure/ranking-eval';
import { useSiloKey } from 'util/datastore';

export default function RankingEvalSideBySideRedirect() {
    const router = useRouter();
    const siloKey = useSiloKey();
    const instanceKey = useFirstConversationKey();

    useFocusEffect(() => {
        if (instanceKey) {
            router.replace(
                {
                    pathname: './[instanceKey]',
                    params: {
                        siloKey,
                        instanceKey,
                    },
                },
                {
                    relativeToDirectory: true,
                },
            );
        }
    });

    return <LoadingSpinnerContainer />;
}
